/* file description */
import React, { useContext, useImperativeHandle, useState } from 'react';
import { Button, Modal, Space } from 'antd';
import componentsList from './componets';
import { MetaState } from '@/store/useMetaStore';
import { RelationTreeType } from '@/asset/AssetTask/templates/Cascade/type';

interface EventInfo {
  name: string;
  config: any;
}

interface MetaConfigType extends MetaState {
  freeComponentsConfig: any;
  relationSchema: RelationTreeType;
  index?: number;
  reload: () => void;
}

export interface SpComListType {
  values?: Record<string, any>;
  onChange?: any;
  rulesMap?: any;
  metaConfig?: MetaConfigType;
  _rowId?: string;
  _headId?: string;
  refList?: any;
}

const SpComList: React.FC<SpComListType> = (props) => {
  const { metaConfig } = props;
  if (!componentsList[metaConfig?.freeComponentsConfig?.type]) {
    return null;
  }
  return React.createElement(componentsList[metaConfig?.freeComponentsConfig?.type], { ...props }, null);
};

export default SpComList;
